import { Font, PageEmpty, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans } from 'react-i18next'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  empty: {
    marginVertical: Spacing.L,
  },

  highlight: {
    fontFamily: Font.medium,
  },
})

interface Props {
  search?: string
}

const CompanyEmpty = (props: Props) => {
  const { search } = props

  if (search) {
    return (
      <PageEmpty testID="CompanySelect.EmptySearch">
        <Text level={2}>
          <Trans>
            No results matching{' '}
            <Text level={2} style={styles.highlight}>
              {/* @ts-expect-error Typing of vars in trans not working correctly  */}
              {{ search }}
            </Text>
          </Trans>
        </Text>
        <Text style={styles.empty}>
          <Trans>Try adjusting search or filter to find what you're looking for.</Trans>
        </Text>
      </PageEmpty>
    )
  }
  return (
    <PageEmpty testID="CompanySelect.Empty">
      <Text level={2}>
        <Trans>There's nothing here yet</Trans>
      </Text>
      <Text style={styles.empty}>
        <Trans>
          There is no company available for you yet. Ask your administrator to provide access via the user management
          environment.
        </Trans>
      </Text>
    </PageEmpty>
  )
}

export default CompanyEmpty
